import { useEffect } from "react"
import { useLocation, Redirect } from "react-router-dom"
import styled from "styled-components"
import downoadBas64 from "../../../helpers/download-base64"
const Wrapper = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const Img = styled.img`
  max-width: 90%;
`
const Button = styled.button`
  outline: none;
  line-height: 36px;
  background: transparent;
  border: 1px solid black;
  min-width: 150px;
  cursor: pointer;
`

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const FinalProduct = () => {
  const { state } = useLocation()

  if (!state?.resultImg) {
    return <Redirect to="/cart/choose" />
  }

  const name = `vending-cart-${state?.cart?.name}-customized`
  const onDownload = () => {
    downoadBas64(state?.resultImg, name)
  }

  useEffect(() => {
    document.getElementById("extensions").style.padding = 0
  }, [])

  return (
    <Wrapper>
      <Img src={state?.resultImg} alt={name} />
      <ButtonGroup>
        <Button onClick={onDownload}>Download</Button>
        <form action="/vending_cart_upload_image" method="POST">
          <input type="hidden" name="photo" value={state?.resultImg} />
          <Button type="submit">Request Sample</Button>
        </form>
      </ButtonGroup>
    </Wrapper>
  )
}

export default FinalProduct
